import { components } from 'gmap-vue'

export default ({ Vue }) => {
  Vue.component('gmap-cluster', components.Cluster)
}
